import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { charterSelector } from '../../../../../../../store/reducers/charterSlice/charterSlice';
import { positionSelector } from '../../../../../../../store/reducers/positionSlice/positionSlice';
import { MonthModeCharter } from '../MonthModeCharter/MonthModeCharter';
import { MonthModePosition } from '../MonthModePosition/MonthModePosition';

export const MonthsModeStageChild = ({ childGuid }) => {
    const charters = useSelector(charterSelector.selectEntities);
    const positions = useSelector(positionSelector.selectEntities);

    const chartersGuids = useSelector(charterSelector.selectIds);

    const isCharter = chartersGuids.includes(childGuid);

    return (
        <>
            {isCharter ? (
                <MonthModeCharter charter={charters[childGuid]} />
            ) : (
                <MonthModePosition position={positions[childGuid]} />
            )}
        </>
    );
};
